(function(){
  var MTM = window.__MTM || {};
  var SID = MTM.sid;
  var root = document.getElementById('musee-' + SID);
  if(!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buzz(ms){ if(navigator.vibrate){ try{ navigator.vibrate(ms); }catch(e){} } }
  function track(ev, data){ try{ window.dataLayer = window.dataLayer || []; var o = data || {}; o.event = ev; window.dataLayer.push(o); }catch(e){} }

  var reveals = [].slice.call(root.querySelectorAll('.musee-reveal, .musee-rule, .musee-title-mask'));
  if(reduced || !('IntersectionObserver' in window)){
    reveals.forEach(function(el){ el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, {threshold:.14, rootMargin:'0px 0px -6% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* Titres premium — decoupe mot a mot puis revelation en cascade (masque + glissement incline) */
  var titles = [].slice.call(root.querySelectorAll('.mt-title'));
  function mtWords(host, text, em){
    var parts = text.split(/(\s+)/);
    for(var k=0;k<parts.length;k++){
      var p = parts[k];
      if(p === '') continue;
      if(/^\s+$/.test(p)){ host.appendChild(document.createTextNode(' ')); continue; }
      var w = document.createElement('span'); w.className = 'mt-w';
      var inner = document.createElement(em ? 'em' : 'span');
      inner.textContent = p;
      w.appendChild(inner);
      host.appendChild(w);
    }
  }
  function mtSplit(el){
    if(el.getAttribute('data-mt-split')) return;
    el.setAttribute('data-mt-split','1');
    var src = [].slice.call(el.childNodes);
    el.textContent = '';
    src.forEach(function(node){
      if(node.nodeType === 3){ mtWords(el, node.textContent, false); }
      else if(node.nodeType === 1){ mtWords(el, node.textContent, node.tagName.toLowerCase() === 'em'); }
    });
    var inners = el.querySelectorAll('.mt-w > *');
    for(var i=0;i<inners.length;i++){
      inners[i].style.setProperty('--d', (Math.min(i,14) * 0.06).toFixed(2) + 's');
    }
  }
  if(reduced || !('IntersectionObserver' in window)){
    titles.forEach(function(el){ el.classList.add('is-in'); });
  } else {
    titles.forEach(mtSplit);
    var tio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); tio.unobserve(en.target); }
      });
    }, {threshold:.2, rootMargin:'0px 0px -8% 0px'});
    titles.forEach(function(el){ tio.observe(el); });
  }

  /* Mot géant « rempli » au scroll — calcul throttlé en rAF et actif seulement
     quand le titre est proche du viewport. */
  var giant = document.getElementById('museeGiant-' + SID);
  if(giant && !reduced){
    var fills = [].slice.call(giant.querySelectorAll('.fill'));
    var fillNear = true, fillTicking = false;
    function fillPaint(){
      fillTicking = false;
      var r = giant.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh - r.top) / (vh * .82);
      p = Math.max(0, Math.min(1, p));
      var n = fills.length;
      fills.forEach(function(el, i){
        var seg = Math.max(0, Math.min(1, (p * n) - i));
        el.style.setProperty('--fill', (seg * 100).toFixed(1) + '%');
      });
    }
    function fillScroll(){
      if(!fillNear || fillTicking) return;
      fillTicking = true;
      requestAnimationFrame(fillPaint);
    }
    if('IntersectionObserver' in window){
      fillNear = false;
      new IntersectionObserver(function(entries){
        fillNear = entries[0].isIntersecting;
        if(fillNear) fillScroll();
      }, {rootMargin:'200px 0px'}).observe(giant);
    }
    window.addEventListener('scroll', fillScroll, {passive:true});
    window.addEventListener('resize', fillScroll);
    if(fillNear) fillScroll();
  }

  var CFG_URL = MTM.cfg;
  var overlay = document.getElementById('museeConfig-' + SID);
  var frame   = overlay ? overlay.querySelector('iframe') : null;
  var directLink = overlay ? overlay.querySelector('[data-musee-direct]') : null;
  var currentTxt = undefined, loadSeq = 0;
  var frameMode = null;

  function b64url(s){ return btoa(unescape(encodeURIComponent(s))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }
  function recipeHash(txt){
    var r = { v:1, shape:'hexa', hole:false,
      elements:[{ type:'text', text:txt, x:0.5, y:0.5, size:18, color:'#4a2616' }] };
    try{ return '#d=' + b64url(JSON.stringify(r)); }catch(e){ return ''; }
  }
  function previewParams(){
    try{
      var p = new URLSearchParams(window.location.search), keep = [];
      ['preview_theme_id','_fd','pb'].forEach(function(k){ if(p.has(k)) keep.push(k + '=' + encodeURIComponent(p.get(k))); });
      return keep.join('&');
    }catch(e){ return ''; }
  }
  function cfgBase(){
    var pv = previewParams();
    return pv ? CFG_URL + (CFG_URL.indexOf('?') > -1 ? '&' : '?') + pv : CFG_URL;
  }
  function isPreview(){
    try{
      if(window.Shopify && window.Shopify.designMode) return true;
      if(/shopifypreview\.com/i.test(location.hostname)) return true;
      if(new URLSearchParams(location.search).has('preview_theme_id')) return true;
    }catch(e){}
    return false;
  }
  function directUrl(txt){ return CFG_URL + (txt ? recipeHash(txt) : ''); }
  function syncDirectLink(){ if(directLink) directLink.href = directUrl(currentTxt); }

  function inspectFrame(){
    // Le configurateur (injecte via srcdoc) a charge : on l'affiche.
    frameMode = true;
    if(overlay) overlay.classList.add('is-loaded');
  }
  // IMPORTANT : Shopify bloque l'affichage de ses pages via iframe.src (X-Frame-Options /
  // frame-ancestors) -> page blanche. On recupere donc le HTML par fetch (autorise, meme
  // domaine) puis on l'injecte via srcdoc. C'est la technique de l'ancienne homepage qui marchait.
  var cfgHtmlCache = null, srcdocApplied = false, cfgReady = false;
  function applySrcdoc(){
    if(!frame || cfgHtmlCache == null || srcdocApplied) return;
    srcdocApplied = true;
    frame.onload = function(){ setTimeout(inspectFrame, 60); };
    frame.setAttribute('allow','clipboard-write; fullscreen');
    frame.srcdoc = cfgHtmlCache;
  }
  function fetchCfg(cb){
    if(cfgHtmlCache != null){ if(cb) cb(); return; }
    fetch(CFG_URL, { credentials:'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){ cfgHtmlCache = html; if(cb) cb(); })
      .catch(function(){ /* echec : on garde le chargeur + le lien « Ouvrir en pleine page » */ });
  }
  function loadFrame(txt){
    if(!frame) return;
    currentTxt = txt || null; syncDirectLink();
    if(overlay && !srcdocApplied) overlay.classList.remove('is-loaded');
    if(cfgHtmlCache != null){ applySrcdoc(); }
    else { fetchCfg(applySrcdoc); }
  }
  /* Préchargement du configurateur SUR INTENTION uniquement (survol / contact d'un CTA
     d'ouverture), au lieu d'un téléchargement systématique en tâche de fond. */
  (function(){
    var conn = navigator.connection || {};
    if(conn.saveData) return;
    if(conn.effectiveType && /(^|-)2g$/.test(conn.effectiveType)) return;
    var CTA_SEL = '[data-musee-open], .mt-open-config, [data-musee-direct]';
    var armed = false;
    function intent(e){
      if(armed) return;
      var t = e.target;
      if(!t || !t.closest || !t.closest(CTA_SEL)) return;
      armed = true;
      document.removeEventListener('pointerover', intent, true);
      document.removeEventListener('touchstart', intent, true);
      document.removeEventListener('focusin', intent, true);
      fetchCfg(null);
    }
    document.addEventListener('pointerover', intent, true);
    document.addEventListener('touchstart', intent, {capture:true, passive:true});
    document.addEventListener('focusin', intent, true);
  })();

  var sticky = document.getElementById('museeSticky-' + SID);
  var hero = root.querySelector('.musee-hero') || document.getElementById('mt-photo-hero');
  var overlayOpenFlag = false;
  var heroH = 0, stickyTicking = false;
  function measureHero(){ heroH = hero ? hero.offsetHeight : 0; }
  function stickyPaint(){
    stickyTicking = false;
    if(!sticky || !hero) return;
    if(!heroH) measureHero();
    var past = window.scrollY > heroH * .85;
    var nearEnd = (window.innerHeight + window.scrollY) > (document.documentElement.scrollHeight - 300);
    sticky.classList.toggle('show', past && !nearEnd && !overlayOpenFlag);
  }
  function stickyUpdate(){
    if(stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(stickyPaint);
  }
  window.addEventListener('scroll', stickyUpdate, {passive:true});
  window.addEventListener('resize', function(){ measureHero(); stickyUpdate(); });
  measureHero();
  stickyPaint();

  var lastFocus = null;
  function openConfig(){
    if(frame)frame.__mtCloseAskedAt=0;
    track('mt_config_open');
    buzz(12);
    if(!overlay) return;
    lastFocus = document.activeElement;
    hideConfirm();
    loadFrame(null);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    overlayOpenFlag = true; stickyPaint();
    var c = overlay.querySelector('[data-musee-close]');
    if(c) c.focus();
  }
  function closeConfig(approved){
    if(frame&&srcdocApplied&&approved!==true){requestClose();return;}
    if(!overlay) return;
    hideConfirm();
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    overlayOpenFlag = false; stickyPaint();
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // --- Avancement (3 traits) + bouton Retour pilotes par le configurateur (postMessage) ---
  var progDots = overlay ? overlay.querySelectorAll('.musee-config-prog i') : [];
  var backBtn  = overlay ? overlay.querySelector('[data-musee-back]') : null;
  var currentStep = 1;
  function setStep(step, canBack){
    currentStep = step;
    for(var i=0;i<progDots.length;i++){ progDots[i].classList.toggle('on', i < step); }
    if(backBtn) backBtn.hidden = !canBack;
  }
  function goBackInConfig(){ if(frame && frame.contentWindow){ try{ frame.contentWindow.postMessage({mtcfg:'back'}, '*'); }catch(e){} } }

  // --- Confirmation avant de quitter (seulement si une tomette est en cours, etape >= 2) ---
  var confirmBox = overlay ? overlay.querySelector('[data-musee-confirm]') : null;
  function showConfirm(){ if(confirmBox){ confirmBox.hidden = false; var g=confirmBox.querySelector('[data-musee-quit]'); if(g)g.focus(); } }
  function hideConfirm(){ if(confirmBox){ confirmBox.hidden = true; } }
  function requestClose(){
    /* La confirmation vit DANS l'atelier : son popup sait sauvegarder la
       tomette par email (+ newsletter) avant de quitter — le nôtre ne
       savait que quitter. Tant que l'atelier est chargé, on lui délègue ;
       le X comme le clic à côté passent par ici. */
    if(frame && srcdocApplied){
      try{if(typeof frame.contentWindow._mtAskClose==='function'){frame.contentWindow._mtAskClose();if(frame)frame.__mtCloseAskedAt=0;return;}}catch(e){}
      var now=Date.now();
      if(frame.__mtCloseAskedAt && now-frame.__mtCloseAskedAt>=2000){
        frame.__mtCloseAskedAt=0;
        if(window.confirm(/^en\b/i.test((window.MT_CONFIG_I18N||{}).locale||document.documentElement.lang||'') ? 'The editor is not responding. Leave without saving? Your design may be lost.' : 'L’éditeur ne répond pas. Quitter sans enregistrer ? Votre création risque d’être perdue.')) closeConfig(true);
        return;
      }
      if(!frame.__mtCloseAskedAt)frame.__mtCloseAskedAt=now;
      try{frame.contentWindow.postMessage({mtcfg:'requestClose'},'*');}catch(e){}
      return;
    }
    closeConfig(true);
  }

  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-musee-open], .mt-open-config');
    if(o){ e.preventDefault(); openConfig(); return; }
    if(e.target.closest('[data-musee-stay]')){ hideConfirm(); return; }      // « Continuer ma tomette »
    if(e.target.closest('[data-musee-quit]')){ closeConfig(); return; }      // « Quitter »
    if(e.target.closest('[data-musee-back]')){ goBackInConfig(); return; }   // Retour (etape precedente)
    var c = e.target.closest('[data-musee-close]');
    if(c){ requestClose(); return; }                                        // Fermer -> confirmation
    if(overlay && e.target === overlay && overlay.classList.contains('is-open')){ requestClose(); } // clic a cote -> confirmation
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape' || !overlay || !overlay.classList.contains('is-open')) return;
    if(confirmBox && !confirmBox.hidden){ hideConfirm(); return; }           // Echap referme d'abord la confirmation
    requestClose();
  });
  // Messages venant du configurateur (iframe srcdoc) : avancement, fermeture, navigation panier/checkout.
  window.addEventListener('message', function(ev){
    if(!frame || ev.source !== frame.contentWindow) return;
    var d = ev && ev.data;
    if(d && d.mtcfg === 'step'){ cfgReady=true; setStep(d.step || 1, !!d.canBack); return; }
    if(!overlay || !overlay.classList.contains('is-open')) return;
    if(d === 'mtcfg-close' || (d && d.mtcfg === 'close')){ closeConfig(true); return; }
    if(d && d.mtcfg === 'nav' && typeof d.url === 'string'){ window.location.href = d.url; return; }
  });

  /* Carrousel « déjà chez eux » — mur défilant (auto + glisser + flèches). Le drag ne doit pas déclencher le lien des vignettes cliquables. */
  var mWall = document.getElementById('museeWall-' + SID);
  if(mWall){
    var mWrap = mWall.closest('.musee-wall-wrap');
    [].slice.call(mWall.children).forEach(function(node){ mWall.appendChild(node.cloneNode(true)); });
    /* Demi-largeur mise en cache : évite de lire scrollWidth (reflow forcé) à chaque frame.
       Invalidée au resize et après un drag. */
    var mHalfCache = 0;
    function mHalf(){ if(!mHalfCache) mHalfCache = mWall.scrollWidth/2; return mHalfCache; }
    window.addEventListener('resize', function(){ mHalfCache = 0; });
    window.addEventListener('load', function(){ mHalfCache = 0; });
    var mPaused=false, mDrag=false, mSx=0, mSl=0, mMoved=false, mArmed=false, mPid=null;
    if(!reduced){
      /* La boucle ne tourne que si le carrousel est visible ET l'onglet actif. */
      var mVisible = true, mRafId = 0;
      function mLoop(){
        if(!mPaused && !mDrag){
          var h = mHalf();
          mWall.scrollLeft += 0.5;
          if(mWall.scrollLeft >= h) mWall.scrollLeft -= h;
        }
        mRafId = requestAnimationFrame(mLoop);
      }
      function mSleep(){ if(mRafId){ cancelAnimationFrame(mRafId); mRafId = 0; } }
      function wake(){
        if(mRafId || !mVisible || document.hidden) return;
        mRafId = requestAnimationFrame(mLoop);
      }
      if('IntersectionObserver' in window){
        mVisible = false;
        new IntersectionObserver(function(entries){
          mVisible = entries[0].isIntersecting;
          if(mVisible) wake(); else mSleep();
        }, {rootMargin:'200px 0px'}).observe(mWall);
      }
      document.addEventListener('visibilitychange', function(){ if(document.hidden) mSleep(); else wake(); });
      wake();
      mWall.addEventListener('mouseenter', function(){ mPaused=true; });
      mWall.addEventListener('mouseleave', function(){ mPaused=false; });
    }
    // Arme le suivi SANS capturer ni bloquer : un simple clic laisse donc partir le lien natif du <a>.
    mWall.addEventListener('pointerdown', function(e){
      if(e.button && e.button !== 0) return;              // clic gauche / tactile uniquement
      mArmed=true; mDrag=false; mMoved=false; mSx=e.clientX; mSl=mWall.scrollLeft; mPid=e.pointerId;
    });
    mWall.addEventListener('pointermove', function(e){
      if(!mArmed) return;
      var dx = e.clientX - mSx;
      if(!mDrag){
        if(Math.abs(dx) <= 6) return;                     // sous le seuil : on n'entrave pas le clic
        mDrag=true; mMoved=true; mWall.classList.add('is-drag');
        try{ mWall.setPointerCapture(mPid); }catch(_){}    // capture SEULEMENT une fois le glissement confirmé
      }
      mWall.scrollLeft = mSl - dx;
    });
    function mEnd(){
      mArmed=false;
      if(mDrag){ mDrag=false; mWall.classList.remove('is-drag'); var h=mHalf(); if(mWall.scrollLeft<0) mWall.scrollLeft+=h; else if(mWall.scrollLeft>=h) mWall.scrollLeft-=h; }
    }
    mWall.addEventListener('pointerup', mEnd);
    mWall.addEventListener('pointercancel', mEnd);
    // Empeche la navigation UNIQUEMENT si l'utilisateur a réellement fait glisser (drag), pas sur un clic.
    mWall.addEventListener('click', function(e){ if(mMoved){ e.preventDefault(); e.stopPropagation(); mMoved=false; } }, true);
    function mStep(){ var f=mWall.querySelector('.musee-wall-item'); return f ? f.getBoundingClientRect().width + 24 : 300; }
    if(mWrap){
      var mp=mWrap.querySelector('.musee-wall-nav.prev'), mn=mWrap.querySelector('.musee-wall-nav.next');
      if(mn) mn.addEventListener('click', function(){ mWall.scrollBy({left:mStep(), behavior:'smooth'}); });
      if(mp) mp.addEventListener('click', function(){ mWall.scrollBy({left:-mStep(), behavior:'smooth'}); });
    }
  }
})();
